// @flow

import { PaymentTypes } from '../model/props';

const map = {
  'Check update': 'Revisar actualización',
  'Privacy policy updated': 'HEMOS ACTUALIZADO NUESTROS TÉRMINOS Y CONDICIONES Y NUESTRA POLÍTICA DE PRIVACIDAD',
  'Accept mandatory terms': 'Para proteger tus derechos, hemos realizado actualizaciones importantes. Te invitamos a revisar los cambios para seguir utilizando nuestro sistema con plena confianza y seguridad.',
  'Accept privacy policy': 'Aceptar política de privacidad(*)',
  'Accept marketing campaigns': 'Aceptar recibir comunicaciones de ofertas y campañas publicitarias(Opcional)',
  'Reload': 'Recargar',
  'Final customer': 'Consumidor final',
  'Total price': 'Precio total',
  'Container': 'Contenedor',
  'Sign container': 'Contenedor (Opcional)',
  'Enter your information': 'Registre su información',
  'Name': 'Nombre',
  'Lastname': 'Apellido(s)',
  'Email': 'Correo electrónico',
  'Password': 'Contraseña',
  'Next': 'Siguiente',
  'Already a customer? Sign in': '¿Ya eres cliente? Ingresar',
  'Sign in': 'Ingresar',
  'Don\'t have an account? Sign Up': '¿No tienes cuenta? Crear cuenta',
  'Required': 'Requerido',
  'Invalid email address': 'Correo electrónico no válido.',
  'Invalid name': 'Nombre no válido.',
  'Invalid lastname': 'Apellido(s) no válido.',
  'Invalid password': 'Contraseña no válida.',
  'Phone': 'Teléfono',
  'Invalid phone': 'Teléfono no válido.',
  'Forbidden': 'Acceso prohibido',
  'Bad request': 'Petición no válida.',
  'Bad credentials': 'Credenciales no válidas.',
  'No content': 'Sin contenido.',
  'Sign out': 'Cerrar sesión',
  'Sign requests': 'Trámites',
  'Profile': 'Perfil',
  'Request sign': 'Solicitar certificado',
  'Please select person type': 'Por favor seleccione tipo de persona',
  'Person type': 'Tipo de persona',
  'Natural person': 'Persona natural',
  'OK': 'Aceptar',
  'Cancel': 'Cancelar',
  'Confirm to sign out': 'Confirme para cerrar sesión.',
  'Sign duration': 'Duración de certificado',
  'Year': 'Año',
  'Years': 'Años',
  'Month': 'Mes',
  'Months': 'Meses',
  'Day': 'Día',
  'Days': 'Días',
  'Created': 'Creado',
  'Duration': 'Duración',
  'Price': 'Precio',
  'Save': 'Guardar',
  'Personal data': 'Datos personales',
  'Not completed': 'Sin completar',
  'Completed': 'Completado',
  'Legal ID type': 'Tipo de identificación',
  'Legal ID': 'Identificación',
  'Legal ID expires at': 'Expiración de Identificación',
  'ID Document Code': 'Código dactilar',
  'Passport': 'Pasaporte',
  'Ec cedula': 'Cédula',
  'Ec ruc': 'RUC',
  'Birthday': 'Fecha de nacimiento',
  'Province of birth': 'Provincia de nacimiento',
  'City of birth': 'Ciudad de nacimiento',
  'Data saved': 'Datos guardados',
  'Country of residence': 'País de residencia',
  'Province of residence': 'Provincia de residencia',
  'City of residence': 'Ciudad de residencia',
  'Address of residence': 'Dirección de residencia',
  'Country': 'País',
  'Province': 'Provincia',
  'City': 'Ciudad',
  'Address': 'Dirección',
  'Documents data': 'Documentos',
  'Document LEGAL_ID': 'Documento de identificación (frente)',
  'Add document LEGAL_ID': 'Agregar documento de identificación (frente)',
  'Document LEGAL_ID_BACK': 'Documento de identificación (reverso)',
  'Add document LEGAL_ID_BACK': 'Agregar documento de identificación (reverso)',
  'Document BASIC_SERVICE_BILL': 'Factura de servicio básico',
  'Add document BASIC_SERVICE_BILL': 'Agregar factura de servicio básico',
  'Document EC_RUC': 'RUC',
  'Add document COMPANY_CONSTITUTION': 'Agregar escrituras de constitución',
  'Document COMPANY_CONSTITUTION': 'Escrituras de constitución',
  'Add document COMPANY_CUSTOMER_NOMINATION': 'Agregar nombramiento',
  'Document COMPANY_CUSTOMER_NOMINATION': 'Nombramiento',
  'Add document EC_RUC': 'Agregar RUC',
  'Process': 'Procesar',
  'Document saved': 'Documento guardado.',
  'Document removed': 'Documento eliminado.',
  'Payment validated': 'Pago validado',
  'Process state changed': 'El estado del proceso ha sido cambiado.',
  'Network Error': 'Error de conexión.',
  'Your process is DRAFT': 'Complete todos los datos de su solicitud.',
  'Your process is DATA_LOADED': 'Los datos personales han sido completados.',
  'Your process is DOCUMENTS_LOADED': 'Los documentos de solicitud han sido completados.',
  'Your process is BILLING_LOADED': 'Los datos de facturación han sido completados.',
  'Your process is PAYMENT_LOADED': 'El pago ha sido efectuado.',
  'Your process is AGREEMENT_LOADED': 'El acuerdo de contrato ha sido completado.',
  'Your process is VIDEO_LOADED': 'Ha completado su solicitud, un agente le contactará para completar el proceso.',
  'Your process is DATA_VALIDATED': 'Los datos han sido validados.',
  'Your process is DOCUMENTS_VALIDATED': 'Los documentos han sido validados.',
  'Your process is BILLING_VALIDATED': 'Los datos de facturación han sido validados.',
  'Your process is PAYMENT_VALIDATED': 'El pago ha sido validado.',
  'Your process is AGREEMENT_VALIDATED': 'El acuerdo de contrato ha sido validado.',
  'Your process is VIDEO_VALIDATED': 'El video ha sido validado.',
  'Your process is VENDOR_READY': 'En proceso...',
  'Your process is VENDOR_PROCESSING': 'En trámite con el proveedor.',
  'Your process is CUSTOMER_ACTIVATED': 'Activado, pendiente de emisión.',
  'Your process is VENDOR_COMPLETED': 'Trámite completado.',
  'Your process is VENDOR_REJECTED': 'Trámite fallido.',
  'Your process is REVOKED': 'Trámite revocado.',
  'Your process is CANCELLED': 'Trámite cancelado.',
  'Your process is REJECTED': 'Trámite rechazado.',
  'Full name': 'Nombre completo',
  'Zip code': 'Código postal',
  'For invoicing': 'Para facturar',
  'For invoicing description': 'La firma ES para facturación electrónica',
  'Upload limit is MB_SIZE': 'El límite de carga de documentos es {{size}} MB',
  'Unauthorized': 'No autorizado',
  'Legal person': 'Persona jurídica',
  'Company data': 'Datos de empresa',
  'Company rol': 'Cargo en la empresa',
  'Company name': 'Razón social',
  'Company ID': 'RUC',
  'Payment saved': 'Pago guardado',
  'Payment data': 'Datos de pago',
  'Load': 'Cargar',
  'Coupon': 'Cupón',
  'Apply coupon': 'Aplicar cupón',
  'Applied coupon': 'Cupón aplicado',
  'Load link': 'Cargar enlace',
  'Upload proof of payment': 'Subir comprobante de pago',
  'Proof of payment': 'Comprobante de pago',
  'Contract agreement': 'Acuerdo de contrato',
  'Agreement intro': 'Yo {{fullName}} con identificación {{legalID}} autorizo a ARN1 TOUWOLF TECHNOLOGIES la emisión de mi certificado digital de Firma Electrónica.',
  'Legal agreement intro': 'Yo {{fullName}} con identificación {{legalID}} en mi calidad de representante legal de la empresa {{companyData.name}}, con número de RUC {{companyData.legalID}}, autorizo a Autoridad de Registro de Nivel 1 TOUWOLF TECHNOLOGIES S.A, la emisión de los siguientes certificados digitales para los siguientes empleados de esta empresa:',
  'Agreement tributary intro': 'Yo {{fullName}} con identificación tributaria {{tributaryLegalID}} autorizo a ARN1 TOUWOLF TECHNOLOGIES la emisión de mi certificado digital de Firma Electrónica.',
  'Agreement sign use': 'Uso Principal de la Firma: Firma de documentos (No es para facturación electrónica, se requiere copia del RUC)',
  'Tributary agreement sign use': 'Uso Principal de la Firma: Facturación electrónica',
  'Agreement intro 2': 'Particular que pongo en su conocimiento para los fines pertinentes. Relaciono mis datos a continuación:',
  'Agreement acknowledge': 'He revisado y verificado que los datos que constan en el presente documento son correctos, y estoy consciente que los mismos se utilizarán en mi firma electrónica, y que estos datos no podrán ser modificados una vez que se realice la emisión de mi firma electrónica.',
  'Agreement farewell': 'Atentamente',
  'Tributary Name': 'Nombre tributario',
  'Tributary Legal ID': 'Identificación tributaria',
  'Clear': 'Limpiar',
  'Sign the contract agreement please': 'Firme el acuerdo de contrato por favor.',
  'Verification video': 'Imagen de verificación',
  'Validation process': 'Proceso de validación',
  'Upload verification video': 'Subir imagen de verificación manual (LENTO)',
  'Check example': 'Ver ejemplo',
  'Video saved': 'Video guardado',
  'Verification saved': 'Verificación guardada',
  'Validated': 'Validado',
  'See saved agreement': 'Ver contrato guardado',
  'Contract agreement saved': 'Contrato guardado.',
  'Payment type': 'Modo de pago',
  [PaymentTypes.TRANSFER]: 'Transferencia o depósito',
  [PaymentTypes.CREDIT]: 'Crédito',
  [PaymentTypes.CASH]: 'Efectivo',
  [PaymentTypes.CREDIT_CARD]: 'Tarjeta crédito',
  'Go to payment': 'Realizar el pago',
  'Your payment is processing': 'Su pago está siendo procesado, puede cerrar esta ventana.',
  'Your validation is processing': 'Su validación está siendo procesada...',
  'Download template': 'Descargar plantilla',
  'Agreement terms accepted': 'Acepto los términos del contrato',
  'Upload agreement': 'Subir contrato firmado',
  'Video intro': 'Debe leer en el video el siguiente texto',
  'Could not detect camera': 'No se pudo detectar la cámara. Verifique tener los permisos habilitados.',
  'Take Picture': 'Tomar foto',
  'Clear Image': 'Quitar foto',
  'Send Image': 'Enviar foto',
  'Browse validation link': 'Ir al enlace para realizar la validación',
  'Browse validation qr': 'También puede escanear el QR desde su móvil:',
  'Browse selfie link': 'Ir al enlace para tomar la selfie',
  'Browse selfie qr': 'También puede escanear el QR desde su móvil:',
  'Video instructions': 'En la fecha (día - mes - año). Yo, {{name}}, con identificación {{legalID}} autorizo a TOUWOLF TECHNOLOGIES la emisión de mi certificado digital de Firma Electrónica.',
  'Selfie not posible': 'Si no puede tomar la selfie, suba la imagen manualmente (NOTA: La opción manual demora más el proceso).',
  'Selfie intro': 'Tome una selfie con su dispositivo.',
  'Image intro': 'La imagen debe ser del torso de la persona, con la cédula en su mano, legible.',
  'Legal i d': 'Identificación',
  'Id document code': 'Código dactilar',
  'Tributary name': 'Nombre tributario',
  'Tributary legal i d': 'Identificación tributaria',
  'Invalid resource': 'Recurso no válido.',
  'Support phone': 'Soporte',
  'Support text': 'Buenas, mi nombre es {{name}}, necesito ayuda.',
  'Upload': 'Subir',
  'Agent phone': 'Mi agente',
  'Agent support text': 'Buenas, mi nombre es {{name}}, necesito ayuda.',
  'Recover password': 'Recuperar contraseña',
  'Send recovery email': 'Enviar correo de recuperación',
  'We sent you an email with recovery instructions': 'Te enviamos un correo con las instrucciones de recuperación.',
  'Enter your new password': 'Ingrese su nueva contraseña',
  'Change password': 'Cambiar contraseña',
  'Name of people who will use a sign': 'Nombres y apellidos de las personas que van a hacer uso de un certificado digital',
  'Role': 'Cargo',
  'Legal agreement note': 'Nota: Todas las personas, incluido el representante legal, que requieran de un certificado digital de firma electrónica deben constar en la tabla anterior.',
  'Legal representative information': 'Datos representante legal',
  'Legal representative full name': 'Nombres completos del representante legal',
  'RUC address': 'Dirección como está en el RUC',
  'Valid company email': 'Direccion correo electronico empresarial válido',
  'Company phone': 'NO. fijo poner código de país',
  'Billing data': 'Datos de facturación',
  'My personal data': 'Mis datos personales',
  'Billing data saved': 'Datos de facturación guardados.',
  'Agreement client page': 'Página de contrato de cliente',
  'Agreement client page description': 'Envíe a su cliente el siguiente enlace para que acceda a firmar el contrato:',
  'Transfer description': 'Para la cancelación de la firma puede utilizar las vías de transferencia o depósito a través de los datos Cuentas Corrientes:',
  'target to': 'a nombre de',
  'Reference code': 'Código de referencia',
  'Your code': 'Tu código',
  'Links': 'Enlaces',
  'Optional': 'Opcional',
  'Gender': 'Sexo',
  'Gender MALE': 'Hombre',
  'Gender FEMALE': 'Mujer',
  'Country of birth': 'Nacionalidad',
  'Change birthday': 'Seleccione su fecha de nacimiento',
  'Change legal ID expiration': 'Seleccione fecha de expiración del documento de identificación',
  'Accept terms and conditions': 'Acepto términos y condiciones generales',
};

export const lang = 'es';
export const resources = {
  es: {
    translation: map,
  },
};
